import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { PageIndex } from "../../../models";
import { successfulLogin } from "../../../auth/authDataSlice";
import { BusinessActivitiesReportFilter } from "./types";

type PaymentPageState = {
  index: PageIndex;
  filter: BusinessActivitiesReportFilter;
};

const now = new Date();
export const initialState: PaymentPageState = {
  index: {
    itemsPerPage: 20,
    pageNumber: 0,
  },
  filter: {
    dateto: now.toISOString(),
    datefrom: new Date(now.getFullYear(), 0, 1).toISOString(),
  },
};

const name = "businessActivities";

const businessActivitiesSlice = createSlice({
  name,
  initialState,
  reducers: {
    setIndex: (state, action: PayloadAction<PageIndex>) => ({
      ...state,
      index: action.payload,
    }),
    resetPaymentIdices: (state) => ({
      ...state,
      index: {
        itemsPerPage: state.index.itemsPerPage,
        pageNumber: initialState.index.pageNumber,
      },
    }),
    setFilter: (
      state,
      action: PayloadAction<BusinessActivitiesReportFilter>
    ) => ({
      ...state,
      filter: action.payload,
    }),
    removeFilter: (
      state,
      action: PayloadAction<keyof BusinessActivitiesReportFilter>
    ) => ({
      ...state,
      filter: {
        ...state.filter,
        [action.payload]: undefined,
      },
    }),
  },
  extraReducers: (builder) => {
    builder.addCase(successfulLogin, (state) => ({
      ...state,
      index: {
        itemsPerPage: state.index.itemsPerPage,
        pageNumber: initialState.index.pageNumber,
      },
    }));
  },
});

export const {
  setIndex,
  resetPaymentIdices,
  setFilter,
  removeFilter,
} = businessActivitiesSlice.actions;

export default businessActivitiesSlice.reducer;
